var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M49.5 27C49.5 39.4264 39.4264 49.5 27 49.5C14.5736 49.5 4.5 39.4264 4.5 27C4.5 14.5736 14.5736 4.5 27 4.5C39.4264 4.5 49.5 14.5736 49.5 27Z",
    fill: "#A37FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8125 27C20.8125 26.068 21.568 25.3125 22.5 25.3125H25.3125V22.5C25.3125 21.568 26.068 20.8125 27 20.8125C27.932 20.8125 28.6875 21.568 28.6875 22.5V25.3125H31.5C32.432 25.3125 33.1875 26.068 33.1875 27C33.1875 27.932 32.432 28.6875 31.5 28.6875H28.6875V31.5C28.6875 32.432 27.932 33.1875 27 33.1875C26.068 33.1875 25.3125 32.432 25.3125 31.5V28.6875H22.5C21.568 28.6875 20.8125 27.932 20.8125 27Z",
    fill: "#A37FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56233 28.6875C4.52102 28.1304 4.5 27.5677 4.5 27C4.5 26.4323 4.52102 25.8696 4.56233 25.3125H11.25C12.182 25.3125 12.9375 26.068 12.9375 27C12.9375 27.932 12.182 28.6875 11.25 28.6875H4.56233Z",
    fill: "#A37FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 49.4377C28.1304 49.479 27.5677 49.5 27 49.5C26.4323 49.5 25.8696 49.479 25.3125 49.4377V42.75C25.3125 41.818 26.068 41.0625 27 41.0625C27.932 41.0625 28.6875 41.818 28.6875 42.75V49.4377Z",
    fill: "#A37FFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4377 25.3125C49.479 25.8696 49.5 26.4323 49.5 27C49.5 27.5677 49.479 28.1304 49.4377 28.6875H42.75C41.818 28.6875 41.0625 27.932 41.0625 27C41.0625 26.068 41.818 25.3125 42.75 25.3125H49.4377Z",
    fill: "#A37FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 4.56233V11.25C28.6875 12.182 27.932 12.9375 27 12.9375C26.068 12.9375 25.3125 12.182 25.3125 11.25V4.56233C25.8696 4.52102 26.4323 4.5 27 4.5C27.5677 4.5 28.1304 4.52102 28.6875 4.56233Z",
    fill: "#A37FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/Mission.156fd70e6ca55dc6546dd571d9a48ffc.svg";
export { ForwardRef as ReactComponent };